<div class="logements-page">
  <header class="logements-header">
    <div>
      <h2 class="logements-title">{{ 'logements.title' | translate }}</h2>
      <p class="logements-subtitle">{{ 'logements.subtitle' | translate }}</p>
    </div>

    <a [routerLink]="routes.ajoutLogements" class="logements-action-btn">
      <fa-icon icon="plus"></fa-icon>
      {{ 'logements.add' | translate }}
    </a>
  </header>

  @if (loading) {
    <p class="logements-status">{{ 'common.loading' | translate }}</p>
  }
  @if (error) {
    <p class="logements-status logements-status--error">
      {{ 'logements.loadError' | translate }}
    </p>
  }

  @if (!loading && !error) {
    <label class="logements-search">
      <span class="sr-only">{{ 'common.search' | translate }}</span>
      <input
        type="search"
        [(ngModel)]="query"
        [placeholder]="'logements.searchPlaceholder' | translate"
        />
      </label>
      @if (biens.length === 0) {
        <p class="logements-empty">
          {{ 'logements.empty' | translate }}
          <a [routerLink]="routes.ajoutLogements">{{ 'logements.add' | translate }}</a>
        </p>
      }
      @if (biens.length > 0 && (biens | search: query).length === 0) {
        <p
          class="logements-empty"
          >
          {{ 'logements.noResults' | translate }}
        </p>
      }
      @if (biens.length > 0) {
        <ul class="logements-list">
          @for (bien of biens | search: query; track bien) {
            <li>
              @if (bien.idBienDto) {
                <a
                  class="logements-row"
                  [routerLink]="[routes.logements, bien.idBienDto]"
                  >
                  <h3>{{ bien.titreDto || ('common.untitled' | translate) }}</h3>
                  @if (adresse(bien)) {
                    <p>{{ adresse(bien) }}</p>
                  }
                  <p class="logements-row-meta">{{ unites(bien) }}</p>
                </a>
              }
            </li>
          }
        </ul>
      }
    }
  </div>
